var _rect, _path, _path2, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnssFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 540 540",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.57,
    y: 54.178,
    width: 428.86,
    height: 431.64,
    rx: 40.38,
    fill: "#fff",
    stroke: "#3d8c34",
    strokeWidth: 5.085,
    strokeWidth: 2.78481
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m235.92 242.84c30.408-29.931 62.846-58.708 100.98-78.449 41.751-20.936 60.02-1.99 41.393 40.319-17.672 39.802-46.17 73.435-76.219 104.28-30.846 30.05-64.518 58.588-104.28 76.26-41.911 18.468-61.493 0.757-40.319-41.434 19.702-38.17 48.558-70.569 78.449-100.98zm0 0c-29.573 30.33-57.752 63.684-75.026 102.53-15.92 37.175-3.98 50.747 33.513 32.399 37.294-19.344 69.374-47.763 99.225-77.217 29.851-29.453 57.911-61.932 77.254-99.226 18.11-36.897 5.214-49.554-32.438-33.513-38.966 17.274-72.2 45.453-102.53 75.026z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m298.55 252.26c29.931 30.766 58.707 63.586 78.449 102.16 20.936 42.243 1.99 60.726-40.319 41.88-39.802-17.879-73.435-46.712-104.28-77.116-30.05-31.209-58.588-65.277-76.26-105.51-18.469-42.404-0.757-62.216 41.433-40.793 38.171 19.933 70.57 49.129 100.98 79.371zm0 0c-30.33-29.92-63.684-58.431-102.53-75.908-37.175-16.108-50.747-4.027-32.399 33.907 19.344 37.733 47.763 70.19 77.217 100.39 29.453 30.202 61.932 58.592 99.226 78.163 36.897 18.323 49.554 5.276 33.513-32.819-17.274-39.424-45.454-73.049-75.026-103.74z",
    fill: "url(#a)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.55,
    cy: 51.392,
    rx: 47.342,
    ry: 48.734,
    fill: "#1ea707"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 250.17,
    x2: 180.55,
    y1: 309.05,
    y2: 241.75,
    gradientTransform: "translate(54.178 2.2537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8C34",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 175.91,
    x2: 244.02,
    y1: 319.24,
    y2: 249.6,
    gradientTransform: "translate(54.178 2.2537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D8C34",
    stopOpacity: 0,
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnssFill);
export default __webpack_public_path__ + "static/media/gnss-fill.8f47fa728e25ade9884ff4ccde45a5a0.svg";
export { ForwardRef as ReactComponent };